import {AppLanguage} from 'platform/locale';

import {isNil} from 'ramda';

import {getSafely, Nullish} from 'shared/web';

import {AuditCategory, RelatedAction, Translation} from '../api/digitalCertificateApi';
import {getAuditFieldValue} from './getAuditFieldValue';
import {getRelatedActionByComparisonKey} from './getRelatedActionByComparisonKey';
import {isCebiaWorkspace} from './isCebiaWorkspace';

export function getTooltipText({
  relatedAction,
  auditValueKey,
  language,
}: {
  relatedAction: RelatedAction | Nullish;
  auditValueKey: string | Nullish;
  language: AppLanguage;
}) {
  if (!isCebiaWorkspace() || isNil(relatedAction) || isNil(auditValueKey)) {
    return null;
  }

  const relatedActionValueByKey = relatedAction?.values?.find(
    (relatedActionValue) => relatedActionValue.value === auditValueKey
  );

  if (relatedActionValueByKey) {
    const tooltipText = getSafely(relatedActionValueByKey?.label, language as keyof Translation);

    if (tooltipText) {
      return tooltipText;
    }
  }

  return null;
}

export function getTooltipTextByComparisonKey({
  showForAuditValueKey,
  comparisonKey,
  relatedActions,
  auditCategories,
  language,
}: {
  showForAuditValueKey: string | string[];
  comparisonKey: string;
  relatedActions: RelatedAction[];
  auditCategories: AuditCategory[];
  language: AppLanguage;
}) {
  if (!isCebiaWorkspace()) {
    return null;
  }

  const auditValueKey = getAuditFieldValue({
    key: comparisonKey,
    relatedActions,
    auditCategories,
  });

  const showForAuditValueKeys = Array.isArray(showForAuditValueKey)
    ? showForAuditValueKey
    : [showForAuditValueKey];

  if (!auditValueKey || !showForAuditValueKeys.includes(auditValueKey)) {
    return null;
  }

  return getTooltipText({
    relatedAction: getRelatedActionByComparisonKey(comparisonKey, relatedActions),
    auditValueKey,
    language,
  });
}
